import router from '@/router';
import { getOpenReviewContractProperties } from '@/functions/pages/review_contract';

const getReviewWindowNameList = () => {
  return JSON.parse(window.localStorage.getItem('reviewWindowNameList'));
};

const setReviewWindowNameList = list => {
  window.localStorage.setItem('reviewWindowNameList', JSON.stringify(list));
};

export const review = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    selectedUserTemplateHead: null
  },
  getters: {
    getselectedUserTemplateHead: state => state.selectedUserTemplateHead
  },
  mutations: {
    setSelectedUserTemplateHead(state, payload) {
      state.selectedUserTemplateHead = payload;
    },
    pushWindowName(state, payload) {
      let list = getReviewWindowNameList();
      if (!list) {
        list = [payload.windowName];
      } else {
        list.push(payload.windowName);
      }
      setReviewWindowNameList(list);
    },
    clear() {
      setReviewWindowNameList([]);
    },
    removeItemFromWindowNameList(state, payload) {
      const list = getReviewWindowNameList();
      const filteredList = list.filter(i => i !== payload);
      setReviewWindowNameList(filteredList);
    }
  },
  actions: {
    setSelectedUserTemplateHead({ commit }, payload) {
      commit('setSelectedUserTemplateHead', payload);
    },
    openWindow({ commit, dispatch }, payload) {
      const { userContractRootId } = payload;
      const routeData = router.resolve({
        name: 'ReviewContract',
        query: { userContractRootId: userContractRootId }
      });
      commit('pushWindowName', { windowName: userContractRootId });
      window.open(routeData.href, userContractRootId, getOpenReviewContractProperties());
      window.CallParentfunction = function() {
        dispatch('userSettings/setUserDialogSettings', null, { root: true });
      };
    },
    destroy({ commit }) {
      const list = getReviewWindowNameList();
      list &&
        Array.isArray(list) &&
        list
          .filter((value, index, self) => {
            return self.indexOf(value) === index;
          })
          .forEach(windowName => {
            setTimeout(() => {
              window.open('', windowName, true).close();
            }, 1);
          });
      commit('clear');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/review.js